/**
 * Metal Switcher — default selection on page load.
 * The click handling is inline Alpine (@click) calling onSubmit() from xFiltersAndSortby scope.
 * This script only handles auto-selecting the default metal when no filter is active.
 */
(function() {
  window._mioMetalInit = function(container) {
    var inputs = container.querySelectorAll('.mio-metal-input');
    var hasActive = false;
    inputs.forEach(function(input) { if (input.checked) hasActive = true; });
    if (hasActive) {
      // Mark the active button wrapper
      inputs.forEach(function(input) {
        if (input.checked) input.closest('.mio-metal-pill').classList.add('is-active');
      });
      return;
    }

    // Auto-select default metal
    var defaultMetal = container.dataset.defaultMetal;
    if (!defaultMetal) return;
    var defaultLower = defaultMetal.toLowerCase();

    var match = null;
    inputs.forEach(function(input) {
      if (!match && input.value.toLowerCase().indexOf(defaultLower) !== -1) {
        match = input;
      }
    });

    if (match) {
      match.checked = true;
      match.closest('.mio-metal-pill').classList.add('is-active');
      // Trigger the facet filter via a click on the button
      // Small delay to ensure xFiltersAndSortby is initialized
      setTimeout(function() {
        match.closest('.mio-metal-pill').click();
      }, 200);
    }
  };
})();
